function getCookieByName(_name: string) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" + _name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(
  name: string,
  value: string,
  options: { [key: string]: any }
) {
  options = { ...options, path: "/" } || { path: "/" };
  var expires = options.expires;
  if (typeof expires == "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }

  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);
  var updatedCookie = name + "=" + value;

  for (var propName in options) {
    updatedCookie += "; " + propName;
    var propValue = options[propName];

    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  document.cookie = updatedCookie;
}

function deleteCookie(_name: string) {
  setCookie(_name, "", { expires: -1 });
}

export { getCookieByName, setCookie, deleteCookie };
